import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconHistogramM: FC<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1.00004 8.52499C1.00004 8.13839 1.31344 7.82499 1.70004 7.82499C2.08663 7.82499 2.40003 8.13839 2.40003 8.52499V14.1249C2.40003 14.5115 2.08663 14.8249 1.70004 14.8249C1.31344 14.8249 1.00004 14.5115 1.00004 14.1249V8.52499Z" />
    <path d="M5.48 1.31506C5.76722 1.09965 6.17084 1.13645 6.41436 1.40026L10.209 5.51107L13.9116 3.04261C14.2333 2.82817 14.6679 2.91509 14.8824 3.23675C15.0968 3.55842 15.0099 3.99303 14.6882 4.20747L10.4883 7.00745C10.2018 7.19839 9.81909 7.15275 9.58561 6.89981L5.81435 2.81428L2.12003 5.58503C1.81076 5.81698 1.372 5.7543 1.14004 5.44503C0.908082 5.13575 0.970762 4.69699 1.28004 4.46503L5.48 1.31506Z" />
    <path d="M5.20001 7.125C5.20001 6.7384 5.51341 6.425 5.9 6.425C6.2866 6.425 6.6 6.7384 6.6 7.125V14.1249C6.6 14.5115 6.2866 14.8249 5.9 14.8249C5.51341 14.8249 5.20001 14.5115 5.20001 14.1249V7.125Z" />
    <path d="M13.5999 8.52499C13.5999 8.13839 13.9133 7.82499 14.2999 7.82499C14.6865 7.82499 14.9999 8.13839 14.9999 8.52499V14.1249C14.9999 14.5115 14.6865 14.8249 14.2999 14.8249C13.9133 14.8249 13.5999 14.5115 13.5999 14.1249V8.52499Z" />
    <path d="M9.39997 10.625C9.39997 10.2384 9.71337 9.92498 10.1 9.92498C10.4866 9.92498 10.8 10.2384 10.8 10.625V14.1249C10.8 14.5115 10.4866 14.8249 10.1 14.8249C9.71337 14.8249 9.39997 14.5115 9.39997 14.1249V10.625Z" />
  </svg>
)

export const IconHistogram = createIcon({
  name: 'IconHistogram',
  l: IconHistogramM,
  m: IconHistogramM,
  s: IconHistogramM,
  xs: IconHistogramM,
})
